module.exports = __webpack_public_path__ + "static/media/sentry.6f52e5e5.svg";